import * as React from "react";

export const IconBackArrow = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M26.6668 14.6663H10.4402L17.8935 7.21301L16.0002 5.33301L5.3335 15.9997L16.0002 26.6663L17.8802 24.7863L10.4402 17.333H26.6668V14.6663Z" fill="white"/>
  </svg>
);
